<template lang="pug">
AppPopover(
  ref="AppPopover"
  :trigger="trigger"
  lazy
  @click="open"
)
  template(slot="body")
    h5 Time is locked
    ul.list-unstyled.mt-15
      template(v-for="(reason, index) in filteredReasons")
        li(:key="index")
          i.hi.hi-check-circle-filled
          span.ml-5 {{ status(reason) }}
  template(slot="trigger")
    slot(name="trigger")
</template>

<script>
import { without } from 'lodash-es';

export default {
  name: 'TimeEntriesLockedPopover',
  props: {
    trigger: {
      type: String,
      default: 'hover',
    },
    placement: {
      type: String,
      default: 'auto',
    },
    reasons: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filteredReasons() {
      // we won't show anything for timesheet_paid as we already have a `Paid` reason displayed
      return without(this.reasons, 'timesheet_paid');
    },
  },
  methods: {
    status(key) {
      switch (key) {
        case 'processed_paid':
        case 'paid':
          return 'Paid';
        case 'invoiced':
          return 'Invoiced';
        case 'user_invoiced':
          return 'User invoiced';
        case 'timesheet_paid':
        case 'timesheet':
          return 'Timesheet submitted';
        case 'integration':
          return 'Integration synced';
        case 'task_synced':
          return 'Task synced';
        case 'work_break':
          return 'Work break';
        case 'archived':
          return 'Archived';
        case 'no_permission':
        case 'tracking_disabled':
        case 'modify_time_disabled':
        case 'viewer':
          return 'Not allowed';
        case 'view_only':
          return 'View only member';
        default:
          return 'Unknown';
      }
    },
    open() {
      this.$refs.AppPopover.close();
    },
  },
};
</script>
